import { NoticeLoading } from '@fs/zion-icon'
import { LayoutBand, Row } from '@fs/zion-ui'
import React from 'react'

export default function Loading(): JSX.Element {
  return (
    <LayoutBand marginY="sm">
      <Row alignX="center">
        <NoticeLoading size="lg" />
      </Row>
    </LayoutBand>
  )
}
